<template>
  <div class="meetingsPowerBiStep">
    <!-- <vs-popup fullscreen :active.sync="previewPopupActive" title="Report" id="powerBiPreviewPopup">
      <PowerbiReport :reportId="step.reportId" :showLoading="true" />
    </vs-popup> -->
    <div
      ref="grid"
      class="powerBiGridWrapper"
      :class="{ 'isResizing': isResizing }"
      :style="gridStyle"
    >
      <div>
        <vx-card class="h-full overflowDefinition">
          <vs-row vs-justify="flex-end" class="mb-2">
            <button type="button" class="meetingPaneAction" @click="fullscreen">
              <feather-icon icon="Maximize2Icon" svgClasses="w-4 h-4" />
              Fullscreen
            </button>
          </vs-row>
          <div class="relative reportStepWrapper flex justify-center">
            <PowerbiReport
              class="w-full"
              :venueFilter="step.applyVenueFilter"
              :venueFilterColumn="step.venueFilterColumn"
              :venueFilterTable="step.venueFilterTable"
              :workspaceId="step.workspaceId"
              :reportId="step.reportId"
              :filterVenue="meetingInstance.venueId"
              :showLoading="false"
              :showNavbar="false"
              :fitToWidth="showGoogleDocSidebar"
              ref="powerBiReport"
            />
          </div>
        </vx-card>
      </div>
      <div
        class="resizeHandle"
        :class="{ 'isResizing': isResizing }"
        @mousedown.prevent="startResize"
      />
      <div>
        <vx-card class="h-full overflowDefinition">
          <!--   <vs-row vs-justify="center" class="mb-4">
            <h3>Questions</h3>
          </vs-row> -->
          <template v-if="showGoogleDocSidebar">
            <vs-row vs-justify="flex-end" class="mb-2">
              <GoogleDocActions :url="meetingInstance.googleDocumentUrl" @fullscreen="fullscreenDoc" />
            </vs-row>
            <iframe
              ref="docFrame"
              :src="meetingInstance.googleDocumentUrl"
              class="googleDocFrame"
              frameborder="0"
            />
          </template>
          <Question
            v-else
            v-for="question in step.questions"
            :key="question.id"
            :question="question"
            :isEditable="meetingInstance.isEditable"
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Question from "../MeetingQuestion.vue";
import PowerbiReport from "@/components/PowerbiReport";
import GoogleDocActions from "./GoogleDocActions.vue";
export default {
  props: ["step", "meetingInstance"],
  components: { Question, PowerbiReport, GoogleDocActions },
  data() {
    return {
      rightPercent: 50,
      isResizing: false,
      minRightPercent: 24,
      maxRightPercent: 70,
    };
  },
  computed: {
    showGoogleDocSidebar() {
      const hasNoQuestions = !this.step.questions || this.step.questions.length === 0;
      return hasNoQuestions && !!(this.meetingInstance && this.meetingInstance.googleDocumentUrl);
    },
    gridStyle() {
      const right = Math.min(this.maxRightPercent, Math.max(this.minRightPercent, this.rightPercent));
      return {
        gridTemplateColumns: `${100 - right}fr 12px ${right}fr`,
      };
    },
  },
  created() {
    this.rightPercent = this.showGoogleDocSidebar ? 50 : 34;
  },
  beforeDestroy() {
    this.stopResize();
  },
  methods: {
    fullscreen() {
      const report = this.$refs.powerBiReport && this.$refs.powerBiReport.report;
      if (report) report.fullscreen();
    },
    fullscreenDoc() {
      const frame = this.$refs.docFrame;
      if (!frame) return;
      if (document.fullscreenElement) document.exitFullscreen();
      else frame.requestFullscreen();
    },
    startResize(event) {
      this.isResizing = true;
      this.resizeStartX = event.clientX;
      this.resizeStartPercent = this.rightPercent;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(event) {
      if (!this.isResizing || !this.$refs.grid) return;
      const width = this.$refs.grid.getBoundingClientRect().width;
      if (!width) return;
      const deltaPercent = ((this.resizeStartX - event.clientX) / width) * 100;
      const next = this.resizeStartPercent + deltaPercent;
      this.rightPercent = Math.min(this.maxRightPercent, Math.max(this.minRightPercent, next));
    },
    stopResize() {
      if (!this.isResizing) return;
      this.isResizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
      window.dispatchEvent(new Event("resize"));
    },
  },
};
</script>

<style lang="scss">
.meetingPaneAction {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.2;
  font-family: inherit;
  text-decoration: none;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  color: inherit;
}
.meetingPaneAction:hover {
  text-decoration: underline;
}

.meetingsPowerBiStep {
  .overflowDefinition {
    max-height: 70vh;
    overflow-y: auto;
  }

  .googleDocFrame {
    width: 100%;
    height: 70vh;
    border: 0;
  }

  @media (min-height: 900px) {
    .overflowDefinition {
      max-height: calc(100vh - 270px);
    }

    .googleDocFrame {
      height: calc(100vh - 330px);
    }
  }

  .powerBiGridWrapper {
    display: grid;
    align-items: stretch;

    &.isResizing {
      cursor: col-resize;
      user-select: none;

      iframe {
        pointer-events: none;
      }
    }
  }

  .resizeHandle {
    cursor: col-resize;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 4px;
      height: 48px;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.2);
    }

    &:hover::before,
    &.isResizing::before {
      background: rgba(0, 0, 0, 0.45);
    }
  }

  #powerBiPreviewPopup {
    .vs-popup--content {
      height: 100%;
    }
  }

  $maxWidth: 900px;
  .reportStepWrapper {
    display: flex;
    justify-content: center;

    #powerbi-wrapper {
      // aspect-ratio: 4/3;
      max-width: $maxWidth;

      #report-wrapper {
        margin: 0 !important;
        padding-top: min(75%, $maxWidth * 0.75);
      }
    }
  }
}
</style>

